import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { AppCtxComponent } from 'js/reactAppCtx';
import SearchResultsListViewModel from 'viewmodel/SearchResultsListViewModel';

export default class DesSearchResultsAsList extends HTMLElement {

    constructor() {
        super();
    }

    static get observedAttributes() {
        return ['accsessionid', 'acc-session-id', 'locale', 'collaborationspaceid', 'collaborationspace-id',
            'project-id', 'extensions-src', 'remove-facets'];
    }

    connectedCallback() {
        this.classList.add('afx-content-background');
        this.createReactElement();
    }

    attributeChangedCallback(name, oldValue, newValue) {
        ReactDOM.unmountComponentAtNode(this);
        this.createReactElement();
    }

    get collaborationspaceid() {
        return this.getAttribute('collaborationspaceid') || this.getAttribute('collaborationspace-id');
    }

    get accsessionid() {
        return this.getAttribute('acc-session-id') || this.getAttribute('accsessionid');
    }

    get locale() {
        return this.getAttribute('locale');
    }

    get extensionssrc(){
        return this.getAttribute('extensions-src') || this.getAttribute('extensionssrc');
    }

    createReactElement() {
        ReactDOM.render(
            <AppCtxComponent>
                {React.createElement(
                    SearchResultsListViewModel,
                    {
                        accsessionid: this.accsessionid,
                        locale: this.locale,
                        ...this.getProps()
                    },
                    React.createElement('slot')
                )}
            </AppCtxComponent>,
            this);
    }

    getProps() {
        return {
            collaborationspaceid: this.collaborationspaceid,
            extensionssrc:this.extensionssrc,
            projectid: this.getAttribute('project-id'),
            removefacets:this.getAttribute('remove-facets'),
            hideCommands: this.getAttribute('hide-commands'),
            viewId: 'searchResultsListView',
            viewPath: 'viewPath'
        };
    }

    disconnectedCallback() {
        ReactDOM.unmountComponentAtNode(this);
    }
}
if (!window.customElements.get('des-search-results-as-list')) {
    window.customElements.define(
        'des-search-results-as-list',
        DesSearchResultsAsList
    );
}
